export const SET_PATIENTS = 'main/SET_PATIENTS';
export const RESET_PATIENTS = 'main/RESET_PATIENTS';
export const APPEND_PATIENTS = 'main/APPEND_PATIENTS';
export const SET_PATIENT = 'main/SET_PATIENT';
export const REMOVE_PATIENT = 'main/REMOVE_PATIENT';
export const START_SYNCING_PATIENT = 'main/START_SYNCING_PATIENT';
export const STOP_SYNCING_PATIENT = 'main/STOP_SYNCING_PATIENT';

export const setPatients = patients => ({
  type: SET_PATIENTS,
  patients,
});

export const resetPatients = () => ({
  type: RESET_PATIENTS,
});

export const setPatient = patient => ({
  type: SET_PATIENT,
  patient,
});

export const removePatient = patientId => ({
  type: REMOVE_PATIENT,
  patientId,
});


export const appendPatients = patients => ({
  type: APPEND_PATIENTS,
  patients,
});

export const startSyncingPatient = patientId => ({
  type: START_SYNCING_PATIENT,
  patientId,
});

export const stopSyncingPatient = patientId => ({
  type: STOP_SYNCING_PATIENT,
  patientId,
});



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./main/actions/patients-actions.ts